// extracted by mini-css-extract-plugin
export default {"label":"LibrarySectionLabel-module__label_N0ii3"};